define('entities/customers/messages',[
    'app',
    'backbone'
], function (
    App,
    Backbone
) {
    'use strict';

    var CustomerMessageModel = Backbone.Model.extend({    
        idAttribute: 'secId'
    });

    var API = {
        getModel: function (data) {
            if (!data)
                data = {};
            return new CustomerMessageModel(data);
        }
    };

    App.reqres.setHandler('customer:message:model', function (data) {
        return API.getModel(data);
    });
});

